module.exports = __webpack_public_path__ + "static/img/UseCase.a05b73b4.png";